(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventStatusDeleteController',EventStatusDeleteController);

    EventStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventStatus'];

    function EventStatusDeleteController($uibModalInstance, entity, EventStatus) {
        var vm = this;
        vm.eventStatus = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
